import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { HttpHeaders, HttpClient } from "@angular/common/http";
import { Observable, of } from "rxjs";
import { tap, catchError } from "rxjs/operators";

import { GoogleAnalyticsService } from "./google-analytics.service";
import { StoreService } from "./store.service";
import { School } from "../models/school.model";
import { Term } from "../models/term.model";
import { Consent } from "../models/consent.model";
import { SchoolSystem } from "../models/state.model";

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};
@Injectable({
  providedIn: 'root',
})
export class AppClient {
  private schoolUrl = 'api/school';
  private termUrl = 'api/term';
  private consentUrl = 'api/consent';

  payload: Consent = this.store.state.consent;
  schoolName: string = this.store.state.schoolName;

  constructor(private http: HttpClient,
    private router: Router,
    private googleAnalyticsService: GoogleAnalyticsService,
    private store: StoreService) { }

  getSchools(schoolSystem: SchoolSystem): Observable<School[]> {
    return this.http.get<School[]>(this.schoolUrl + `/${schoolSystem}`)
      .pipe(
        tap(_ => console.log('fetched schools')),
        catchError(this.handleError<School[]>('getSchools', []))
      );
  }

  getLatestTerm(): Observable<Term> {
    return this.http.get<Term>(this.termUrl)
      .pipe(
        tap(data => console.log(`fetched term id=${data.id}`)),
        catchError(this.handleError<Term>('getLatestTerm'))
      );
  }

  addConsent(): Observable<Consent> {
    return this.http.post<Consent>(this.consentUrl, this.payload, httpOptions)
      .pipe(
        tap((data: any) => {
          console.log(`added consent w/ id=${data.id}`);
          this.googleAnalyticsService.trackEvent('Submitted', 'Consent', this.schoolName);
        }),
        catchError(this.handleError<Consent>('addConsent'))
      );
  }

  /**
 * Handle Http operation that failed.
 * Let the app continue.
 * @param operation - name of the operation that failed
 * @param result - optional value to return as the observable result
 */
  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // Send the error to remote logging infrastructure
      console.log(error); // log to console instead
      this.googleAnalyticsService.trackError(`${operation} failed: ${error.message}`, true);

      // Transforming error for user consumption
      console.log(`${operation} failed: ${error.message}`);
      this.router.navigate(['/error']);

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

}
